import { AdminOptionableFilter } from "../AdministrateEnumFilter";

export const ClinicOptionsFilter = ({ queryParams, pageSize = 100, ...rest }) => {
  return (
    <AdminOptionableFilter
      resource="clinics"
      queryParams={{ clinic: { order: "clinic_name", direction: "asc", per_page: pageSize }, ...queryParams }}
      searchParam="clinic_name"
      kept
      {...rest}
    />
  );
};
